<app-menu [hasChanges]="loadMenu"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2">
    <h2 class="uppercase">Modulo de pagos pendientes</h2>
    <p>Aqui encontrará las facturas que estan pendientes por pago</p>
</div>
<div class="text-center">
    <img src="assets/img/payu.png" alt="Pagos Payu - Simescco" style="width: 180px;">
    <p>Tienes un pago pendiente por valor de {{this.pagoPendiente |currency}}</p>

    <form #form2 method="post" target="_blank" action="https://checkout.payulatam.com/ppp-web-gateway-payu/">
        <input name="merchantId" type="hidden" value="927127">
        <!--  <input name="ApiKey"          type="hidden"  value="ngC2YUO2mZqlnA3n6721saaj51"> -->
        <input name="accountId" type="hidden" value="934407">
        <input name="description" type="hidden" value="Pago - {{this.tiendaData.nombreTienda}}">
        <input name="referenceCode" type="hidden" value="{{this.reference}}">
        <input name="amount" type="hidden" value="{{this.taxReturnBase + this.tax}}">
        <input name="tax" type="hidden" value="{{this.tax}}">
        <!-- <input name="taxReturnBase" type="hidden" value="{{this.taxReturnBase}}"> -->
        <input name="currency" type="hidden" value="COP">
        <input name="signature" type="hidden" value="{{this.signature}}">
        <input name="paymentMethods" type="hidden" value="EFECTY,OTHERS_CASH,BANK_REFERENCED">
        <input name="buyerEmail" type="hidden" value="{{this.infoUser.email}}">
<!--         <input name="responseUrl" type="hidden" value="http://www.test.com/response">
        <input name="confirmationUrl" type="hidden" value="http://www.test.com/confirmation"> -->
        <button pButton class="p-button p-button-success" (click)="form2.submit()" label="Ir a generar pago" icon="pi pi-check-circle"></button>
    </form>
    <p>Una vez realizado el pago, el sistema lo descarga en el transcurso de dos(2) horas </p>
</div>
<p-toast key="message"></p-toast>